require('./bootstrap');
window.recordSelector = require('./recordselector');

require('./components');

require('./pagination');

require('./csv-button');
